import Button from "../../components/Button";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCompletedStep, resetSteps, setCompletedStep } from "../../utils/localstorage";
import CheckboxText from "../../components/CheckboxText";

const AiLabStep7 = () => {
  const history = useHistory();
  let { labId, labStep } = useParams<any>();
  const maxPart = 2;
  const [part, setPart] = useState(0);

  function nextPart(nextPart: number) {
    //Handel next Part
    if (nextPart > part) {
      setPart(nextPart);
      if (nextPart === maxPart) {
        setCompletedStep(labId, labStep);
      }
    }
  }
  useEffect(() => {
    //Set boxes checked if step all ready done.
    if (getCompletedStep(labId) >= labStep) {
      setPart(maxPart);
    }
  }, []);
  return (
    <div className="w-full h-full" style={{ maxWidth: 640 }}>
      <h1 className="heading-1">Frågor</h1>
      <p>
        Nu har du testat en <span className="abbr">AI</span> och förstår mer hur den funkar. En{" "}
        <span className="abbr">AI</span> är i regel väldigt snabb och duktig på en sak och ganska &ldquo;dum&rdquo; på
        allt annat (som den inte är tränad på).
      </p>
      <div className="p">
        <br />
        <CheckboxText
          text={
            <div>
              Lyckades du få <span className="abbr">AI</span>&#58;n att bli 100&nbsp;% säker på dina böjda streck?
            </div>
          }
          defultChecked={part > 0}
          nextPart={() => {
            nextPart(1);
          }}
        />

        <br />
        {/* Part 1 */}
        {part >= 1 && (
          <CheckboxText
            text={
              <div>
                <span className="abbr">AI</span>&#58;n ser dina former men även deras placering och avstånd till
                varandra påverkar vad den gissar. Gissade
                <span className="abbr"> AI</span>&#58;n rätt på dina cirklar?
              </div>
            }
            defultChecked={part > 1}
            nextPart={() => {
              nextPart(2);
            }}
          />
        )}
        <br />
        <br />
        <br />
      </div>
      {/* Part 2 */}
      {part >= maxPart && (
        <div className="w-full flex justify-center">
          <Button
            text={"klar"}
            onClick={() => {
              resetSteps(labId);
              history.push(`/`);
            }}
          />
        </div>
      )}
      <div className="w-full h-24"></div>
    </div>
  );
};
export default AiLabStep7;
